import { render, staticRenderFns } from "./Accordion2.vue?vue&type=template&id=5645ef5c&scoped=true&"
import script from "./Accordion2.vue?vue&type=script&lang=js&"
export * from "./Accordion2.vue?vue&type=script&lang=js&"
import style0 from "./Accordion2.vue?vue&type=style&index=0&id=5645ef5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5645ef5c",
  null
  
)

export default component.exports